import { AppConfigModel } from '@/models/app/app-config';
import { sessionService } from '@/providers/services/auth/session';


/**
 *
 * This App Config serializer is responsible for converting the Raw format to model.
 *
 */
export class AppConfigSerializer {
  private static INSTANCE = new AppConfigSerializer();

  static get instance() {
    return this.INSTANCE;
  }

  public appConfigModelSerializer(res: any) {
    const result: AppConfigModel = {
      api_endpoint_url: res.api_endpoint_url,
      is_stage_drill_down: res.is_stage_drill_down,
      demo_tenant: res.demo_tenant,
      language: res.language,
      appId: res.appId,
      tenantUrl: res.tenantUrl,
      adminUiAppId: res.adminUiAppId,
      content_providers: res.content_providers || [],
      provider_tools: res.provider_tools || [],
      IS_ALLOW_USER: res.IS_ALLOW_USER,
      S3_BUCKET_ASSETS_BASE_PATH: res.S3_BUCKET_ASSETS_BASE_PATH,
      STATIC_IMAGE_URL: res.STATIC_IMAGE_URL,
      loginPageInfo: res.loginPageInfo,
    };
    return result;
  }

  public appPermissionSerializer(res: any, permission: any, isSuperAdmin: any) {
    const userRole: any = {
      menus: [],
      pages: {},
    };
    if (permission && permission.length && res) {
      permission.map((pageAccess: any) => {
        Object.keys(res).map((menuPages) => {
          if (!userRole.pages.hasOwnProperty(menuPages)) {
            userRole.pages[menuPages] = [];
          }
          Object.keys(res[menuPages]).map((pages) => {
            if (res[menuPages][pages].indexOf(pageAccess) !== -1) {
              if (userRole.menus.indexOf(menuPages) === -1
                && (pages === `${menuPages}-view` || pages === 'all')) {
                userRole.menus.push(menuPages);
              }
              if (userRole.pages[menuPages].indexOf(pages) === -1) {
                userRole.pages[menuPages].push(pages);
              }
            }
          });
        });
      });
    }
    if (isSuperAdmin) {
      userRole.landingPage = '/setup';
    } else if (permission && permission.length > 0 && permission.includes('VIEW_ROSTER')) {
      userRole.landingPage = '/users-rosters';
    } else {
      userRole.landingPage = '/content-registry';
    }

    return userRole;
  }
}

export const appConfigSerializer = AppConfigSerializer.instance;
